import { SubmissionState } from '../../app/core/enums/submission-state.enum';
import { ModuleV1Read, ModuleSubmissionProducerRead } from '../../app/core/models/module-v1-read.model';
import { ModuleLabelKey } from '../../app/core/types/module-label-key.type';

const moduleBadgeTexts: { [key: string]: ModuleLabelKey } = { Shared: 'shared' };
moduleBadgeTexts[SubmissionState.inReview] = 'submitted';
moduleBadgeTexts[SubmissionState.rejected] = 'improvementsNeeded';
moduleBadgeTexts[SubmissionState.approved] = 'public';
moduleBadgeTexts[SubmissionState.unpublished] = 'unpublished';

export function getModuleLabelKey(module: ModuleV1Read, currentUserId?: string): ModuleLabelKey | undefined {
    if (isModuleShared(module, currentUserId)) {
        return moduleBadgeTexts['Shared'];
    }

    const state = getLatestModuleSubmission(module.submissions)?.state;
    return state ? moduleBadgeTexts[state] : undefined;
}

function isModuleShared(module: ModuleV1Read, currentUserId?: string): boolean {
    if (!(currentUserId && currentUserId === module?.producerId)) {
        return true;
    }

    // Show "Shared" badge when it's my module and there are shares available. Exclude public modules from this logic though.
    if (module && currentUserId && currentUserId === module.producerId && module.shares.length > 0 && module.latestPublicVersion == null) {
        return true;
    }
    return false;
}

export function getLatestModuleSubmission(submissions?: ModuleSubmissionProducerRead[]): ModuleSubmissionProducerRead | undefined {
    if (submissions != null && submissions.length > 0) {
        // We need to slice() the array first because it's frozen. Else this will throw an error.
        // https://stackoverflow.com/questions/53420055/error-while-sorting-array-of-objects-cannot-assign-to-read-only-property-2-of/53420326
        const sortedSubmissions = submissions.slice().sort((submissionA: ModuleSubmissionProducerRead, submissionB: ModuleSubmissionProducerRead) => {
            if (submissionA.modifiedAt != null && submissionB.modifiedAt != null) {
                return new Date(submissionA.modifiedAt).getTime() - new Date(submissionB.modifiedAt).getTime();
            } else {
                return 0;
            }
        });
        return sortedSubmissions[sortedSubmissions.length - 1];
    }
}
